export { default } from 'features/menu/routes/menu-object-route';
